import { createSlice } from '@reduxjs/toolkit';

export const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    id: undefined as string | undefined,
  },
  reducers: {
    setNotificationId: (state, action) => {
      state.id = action.payload;
    },
  },
});

export const { setNotificationId } = notificationSlice.actions;

export const { reducer: notificationReducer } = notificationSlice;
